import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router-dom';
import {
  Button,
  ButtonsContainer,
  ButtonWithLoader,
  Paper,
  PaperTitle,
  PaperContent,
  RFFormInput,
  InlineFormRow,
  Col,
  RFFormRadioGroup,
} from 'virtues-bootstrap';

import { FORM_NAMES } from 'constants/forms';

import { rolesForAddPractitionerForm } from 'utilities/userRoles';

import validate from './validate';

import s from './styles.module.scss';

const AddPractitioner = ({ handleSubmit, pristine, submitting }) => (
  <form onSubmit={handleSubmit}>
    <Paper>
      <PaperTitle withBorder>Add practitioner</PaperTitle>
      <PaperContent>
        <InlineFormRow label="Login" labelRequired>
          <Col xs={6}>
            <Field component={RFFormInput} name="username" placeholder="99-rc1" />
          </Col>
        </InlineFormRow>
        <InlineFormRow label="First name" labelRequired>
          <Col xs={6}>
            <Field component={RFFormInput} name="firstName" placeholder="John" />
          </Col>
        </InlineFormRow>
        <InlineFormRow label="Last name" labelRequired>
          <Col xs={6}>
            <Field component={RFFormInput} name="lastName" placeholder="Smith" />
          </Col>
        </InlineFormRow>
        <InlineFormRow label="Email">
          <Col xs={6}>
            <Field
              placeholder="johnsmith@email.com"
              component={RFFormInput}
              name="email"
              type="email"
            />
          </Col>
        </InlineFormRow>
        <InlineFormRow label="Password" labelRequired>
          <Col xs={6}>
            <Field
              spellCheck={false}
              className={s.passField}
              autoComplete="off"
              component={RFFormInput}
              name="password"
              placeholder="••••••••"
              type="text"
            />
          </Col>
        </InlineFormRow>
        <InlineFormRow label="Confirm Password" labelRequired>
          <Col xs={6}>
            <Field
              spellCheck={false}
              className={s.passField}
              autoComplete="off"
              component={RFFormInput}
              name="confirmPassword"
              placeholder="••••••••"
              type="text"
            />
          </Col>
        </InlineFormRow>
        <InlineFormRow label="Role" labelRequired>
          <RFFormRadioGroup groupName="role" radioButtons={rolesForAddPractitionerForm} />
        </InlineFormRow>
      </PaperContent>
    </Paper>
    <ButtonsContainer>
      <Button component={Link} to="/" variant="link">
        Cancel
      </Button>
      <ButtonWithLoader disabled={pristine} loading={submitting}>
        Add practitioner
      </ButtonWithLoader>
    </ButtonsContainer>
  </form>
);

AddPractitioner.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
};

export default reduxForm({
  form: FORM_NAMES.addPractitioner,
  validate,
})(AddPractitioner);
